import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import config from "../../config/config";
import { Link } from "react-router-dom";
var Settings = require("../settings.json");

const HandOutLists = () => {
  const [handoutList, setHandoutList] = useState({});
  const [url, setUrl] = useState(
    config.BASE_URL + Settings["getHandoutList"].replace("type", "A-Z")
  );
  const logInResponse = useSelector((state) => state.loginReducer);
  const userEmail = logInResponse.isLoggedIn ? logInResponse.email : "null";

  useEffect(() => {
    axios
      .get(url, {
        params: {
          email: userEmail,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let result = response.data.response;
          setHandoutList(result);
        } else {
          throw new Error("Something went wrong ...");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [userEmail, url]);

  function changeType(e) {
    if (
      document
        .querySelector(".condition-filter-arrow .icon")
        .classList.contains("condition-filter-arrow-rotate")
    ) {
      document
        .querySelector(".condition-filter-arrow .icon")
        .classList.remove("condition-filter-arrow-rotate");
      document.querySelector(".filter-dropdown-box").style.display = "none";
    } else {
      document
        .querySelector(".condition-filter-arrow .icon")
        .classList.add("condition-filter-arrow-rotate");
      document.querySelector(".filter-dropdown-box").style.display = "block";
    }
  }
  function forDropDownEffect(e) {
    document.querySelector("#selectedFilterOption").innerText =
      e.target.innerText;
    document
      .querySelector(".condition-filter-arrow .icon")
      .classList.remove("condition-filter-arrow-rotate");
    document.querySelector(".filter-dropdown-box").style.display = "none";
    let val = "A-Z";
    if (e.target.textContent !== "") {
      val = e.target.textContent;
    }
    const url = config.BASE_URL + Settings["getHandoutList"];
    let handOutUrl = url.replace("type", val);
    setUrl(handOutUrl);
  }
  return (
    <div className="condition-section">
      <div className="filter-dropdown-box">
        <p
          className="filter-dropdown-options"
          onClick={(e) => forDropDownEffect(e)}
          key="A-Z"
        >
          A-Z
        </p>
        <p
          className="filter-dropdown-options"
          onClick={(e) => forDropDownEffect(e)}
          key="Specialty"
        >
          Specialty
        </p>
      </div>
      <p className="common-condition-text">
        View
        <span className="condition-filter">
          <span id="selectedFilterOption">A-Z</span>
          <span
            className="condition-filter-arrow"
            onClick={(e) => changeType(e)}
          >
            <FontAwesomeIcon icon={faCaretDown} className="icon" />
          </span>
        </span>
        <label className="handOutLabel">Handouts </label>
      </p>

      {Object.keys(handoutList).map((k, index) => {
        return (
          <div
            className="condition-card-open"
            key={"condition-card-open" + index}
          >
            <h4 key={index}>{k}</h4>
            {Object.values(handoutList[k]).map((f, ind) => {
              return (
                <p key={f.id}>
                  {/* {f.topicLocked && <i className="fa fa-lock topic-locked"></i>} */}
                  <i
                    className={`fa ${
                      f.topicLocked
                        ? "fa-lock topic-locked"
                        : "fa-unlock topic-unlocked"
                    }`}
                  ></i>
                  <Link
                    to={"#"}
                    onClick={() =>
                      f.s3Path != null
                        ? (window.location.href = f.s3Path)
                        : null
                    }
                  >
                    {f.fileName}
                  </Link>
                </p>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
export default HandOutLists;
